import * as i0 from '@angular/core';
import { EventEmitter, Directive, Input, Output, NgModule } from '@angular/core';
import Mark from 'mark.js';

let cancelAnimationId;
function animate({ timing, draw, duration }) {
    const start = performance.now();
    cancelAnimationId = requestAnimationFrame(function animate2(time) {
        // timeFraction goes from 0 to 1
        let timeFraction = (time - start) / duration;
        if (timeFraction > 1) {
            timeFraction = 1;
        }
        // calculate the current animation state
        const progress = timing(timeFraction);
        draw(progress); // draw it
        if (timeFraction < 1) {
            cancelAnimationId = requestAnimationFrame(animate2);
        }
    });
}
class MarkjsHighlightDirective {
    constructor(contentElementRef, renderer) {
        this.contentElementRef = contentElementRef;
        this.renderer = renderer;
        this.markjsHighlight = '';
        this.markjsConfig = {};
        this.scrollToFirstMarked = false;
        this.getInstance = new EventEmitter();
    }
    ngOnChanges() {
        if (!this.markInstance) {
            this.markInstance = new Mark(this.contentElementRef.nativeElement);
            this.getInstance.emit(this.markInstance);
        }
        this.hightlightText();
        if (this.scrollToFirstMarked) {
            this.scrollToFirstMarkedText();
        }
    }
    hightlightText() {
        this.markjsHighlight = this.markjsHighlight || '';
        if (this.markjsHighlight && this.markjsHighlight.length <= 2) {
            this.markInstance.unmark();
            return;
        }
        else {
            this.markInstance.unmark({
                done: () => {
                    this.markInstance.mark((this.markjsHighlight || ''), this.markjsConfig);
                }
            });
        }
    }
    scrollToFirstMarkedText() {
        const content = this.contentElementRef.nativeElement;
        const firstOffsetTop = (content.querySelector('mark') || {}).offsetTop || 0;
        this.scrollSmooth(content, firstOffsetTop);
    }
    scrollSmooth(scrollElement, firstOffsetTop) {
        const renderer = this.renderer;
        if (cancelAnimationId) {
            cancelAnimationFrame(cancelAnimationId);
        }
        const currentScrollTop = scrollElement.scrollTop;
        const delta = firstOffsetTop - currentScrollTop;
        animate({
            duration: 500,
            timing(timeFraction) {
                return timeFraction;
            },
            draw(progress) {
                const nextStep = currentScrollTop + progress * delta;
                renderer.setProperty(scrollElement, 'scrollTop', nextStep);
            }
        });
    }
}
MarkjsHighlightDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: MarkjsHighlightDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
MarkjsHighlightDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.3.0", type: MarkjsHighlightDirective, selector: "[markjsHighlight]", inputs: { markjsHighlight: "markjsHighlight", markjsConfig: "markjsConfig", scrollToFirstMarked: "scrollToFirstMarked" }, outputs: { getInstance: "getInstance" }, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: MarkjsHighlightDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[markjsHighlight]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { markjsHighlight: [{
                type: Input
            }], markjsConfig: [{
                type: Input
            }], scrollToFirstMarked: [{
                type: Input
            }], getInstance: [{
                type: Output
            }] } });

class NgxMarkjsModule {
}
NgxMarkjsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: NgxMarkjsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
NgxMarkjsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: NgxMarkjsModule, declarations: [MarkjsHighlightDirective], exports: [MarkjsHighlightDirective] });
NgxMarkjsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: NgxMarkjsModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: NgxMarkjsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [MarkjsHighlightDirective],
                    imports: [],
                    exports: [MarkjsHighlightDirective]
                }]
        }] });

/*
 * Public API Surface of ngx-markjs
 */

/**
 * Generated bundle index. Do not edit.
 */

export { MarkjsHighlightDirective, NgxMarkjsModule };
